import { push } from 'connected-react-router';
import React, { useEffect } from 'react';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { stringToNumber } from '../../helpers/functions';
import {
  createStagedPremium,
  getSingleStagedPremium,
  requestStagedPremiumSettingsStages,
} from '../../reducers/stagedPremiumsWizard';
import StagedPremiumSettingsWizardHOC from './stagedPremiumSettingsWizardHOC';

const StagedPremiumSettingsCreateHOC = () => {
  const stagedPremiumSettingsWizard = useSelector(
    (state) => state.stagedPremiumsWizard
  );
  const premiumSettings = useSelector((state) => state.premiumSettings);
  const dispatch = useDispatch();
  const { search } = useLocation();
  const basedOnCurrentId = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
    if (basedOnCurrentId.get('psId') != null)
      dispatch(getSingleStagedPremium(basedOnCurrentId.get('psId')));
    else dispatch(requestStagedPremiumSettingsStages());
  }, []);

  const handleSubmit = () => {
    const stagesSettingsBody = Object.values(
      stagedPremiumSettingsWizard.stagesSubSettings
    ).map((s) => ({
      ...s,
      underwriterRate:
        stringToNumber(stagedPremiumSettingsWizard.underwriterRatePercentage) *
        0.01 *
        stringToNumber(s.premiumAmount),
      underwriterRatePercentage: stringToNumber(
        stagedPremiumSettingsWizard.underwriterRatePercentage
      ),
      stagedPremiumSubSettingCommissionDtos: Object.values(
        stagedPremiumSettingsWizard.agentCommissionsList
      ).map((c) => ({
        ...c,
        lawsysId: c.id,
        lawsysName: c.name,
        commission:
          stringToNumber(c.commissionPercentage) *
          0.01 *
          stringToNumber(s.premiumAmount),
        commissionPercentage: stringToNumber(c.commissionPercentage),
      })),
    }));
    // evt.preventDefault();
    dispatch(
      createStagedPremium({
        validFrom: new Date(
          stagedPremiumSettingsWizard.validFrom
        )?.toDateString(),
        validUntil:stagedPremiumSettingsWizard.validUntil ? new Date(
          stagedPremiumSettingsWizard.validUntil
        )?.toDateString() : null,
        notes: stagedPremiumSettingsWizard.notes,
        comments: stagedPremiumSettingsWizard.comments,
        solicitorGroupId:
          premiumSettings.selectedSolicitorGroup === ''
            ? null
            : parseInt(premiumSettings.selectedSolicitorGroup),
        caseTypeId: parseInt(premiumSettings.selectedCaseType),
        subCaseTypeId:
          premiumSettings.selectedSubCaseType === '' ||
          premiumSettings.selectedSubCaseType === '0'
            ? null
            : parseInt(premiumSettings.selectedSubCaseType),
        workSourceId:
          premiumSettings.selectedWorksource === ''
            ? null
            : parseInt(premiumSettings.selectedWorksource),
        DeductibleOptionId: stagedPremiumSettingsWizard.selectedDeductible,
        CoverageOptionId: stagedPremiumSettingsWizard.selectedCoverageType,
        EndorsementOptionId: stagedPremiumSettingsWizard.selectedEndorsement,
        StagedPremiumSubSettings: stagesSettingsBody,
        averageExpectedPremium: stagedPremiumSettingsWizard.averageExpectedPremium,
      })
    );
  };

  return (
    <StagedPremiumSettingsWizardHOC
      isApplicationPremium={false}
      handleSubmit={handleSubmit}
      onCancel={() => dispatch(push('../premium-settings'))}
      isEdit={false}
    />
  );
};

export default StagedPremiumSettingsCreateHOC;
